import { render, staticRenderFns } from "./ApplicantFormStep5.vue?vue&type=template&id=4bdb45a3&scoped=true"
import script from "./ApplicantFormStep5.vue?vue&type=script&lang=js"
export * from "./ApplicantFormStep5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdb45a3",
  null
  
)

export default component.exports